// Modelos LLM curados para el agente (mapean a provider:model del backend).
export const AGENT_MODEL_OPTIONS = [
  { value: "anthropic:claude-sonnet-4-6", label: "Claude Sonnet (recomendado)" },
  { value: "anthropic:claude-opus-4-6", label: "Claude Opus" },
  { value: "openai:gpt-5.4", label: "GPT-5.4" },
  { value: "gemini:gemini-3.1-pro-preview", label: "Gemini 3.1 Pro" },
];

// Fix AJ (2026-10-23): sugerencias de modelo para la cuenta propia de OpenAI
// (al probar la conexion se reemplazan por los modelos reales de la cuenta).
export const OPENAI_MODEL_SUGGESTIONS = ["gpt-4.1-mini", "gpt-4.1", "gpt-4o-mini", "gpt-4o", "gpt-5.4"];

export const AGENT_LANGUAGE_OPTIONS = [
  { value: "es", label: "Español" },
  { value: "en", label: "English" },
];
